/** Maps legacy error messages to canonical error codes. */
const legacyToCanonical = {
    CANNOT_RECORD_ON_THIS_PHONE: 'DEVICE_CANNOT_VOICE_RECORD',
};
/** Normalizes legacy error messages into canonical error codes. */
export const toCanonicalErrorCode = (legacyMessage) => {
    var _a;
    return (_a = legacyToCanonical[legacyMessage]) !== null && _a !== void 0 ? _a : legacyMessage;
};
/** Adds a canonical `code` field to Error-like objects when possible. */
export const attachCanonicalErrorCode = (error) => {
    if (!error || typeof error !== 'object') {
        return;
    }
    const messageValue = error.message;
    if (typeof messageValue !== 'string') {
        return;
    }
    error.code = toCanonicalErrorCode(messageValue);
};
//# sourceMappingURL=error-codes.js.map